<div class="heroBanner bgPrimary">
  <div class="container">
    <h1 class="colorWhite text-center">Explore Crosswind Sermons</h1>
  </div>
</div>

<div class="bgWhite py-80">
  <div class="container">
    <form
      class="form-inline d-flex mx-auto justify-content-around mb-3"
      [formGroup]="filterFrom"
    >
      <div class="form-group mx-sm-3 mb-2">
        <label class="fontBlk mr-3">Speaker</label>
        <select class="form-control" formControlName="authorId">
          <option value="all">All</option>
          <option *ngFor="let item of getUserArray" value="{{ item.id }}">
            {{ item.firstName }} {{ item.lastName }}
          </option>
        </select>
      </div>
      <div class="form-group mx-sm-3 mb-2">
        <label class="fontBlk mr-3">Language</label>
        <select class="form-control" formControlName="category">
          <option value="all">All</option>
          <option value="english">English</option>
          <option value="tagalog">Tagalog</option>
        </select>
      </div>
      <!-- <div class="form-group mx-sm-3 mb-2">
                <select class="form-control">
                    <option>Default select</option>
                </select>
            </div> -->
    </form>
    <div
      class="audiorowPart"
      *ngFor="
        let element of filtredSermonArray
          | paginate : { itemsPerPage: 10, currentPage: p }
      "
      style="background-color: #f78e41"
    >
      <div class="col-12 col-md-11 col-lg-11 px-0 d-flex flex-wrap">
        <div class="audioImg">
          <img
            style="max-height: 90px"
            src="{{ apiUrl }}{{ element?.profile }}"
            class="img-fluid"
          />
        </div>
        <div class="audioDetails">
          <h4 class="colorWhite">{{ element.heading }}</h4>
          <p class="colorWhite">
            SERMON BY {{ element.firstname | uppercase }}
            {{ element.lastName | uppercase }} -
            {{
              convertToLocalDate(element.sermonsDate) | date : "MMM dd, yyyy"
            }}
          </p>
          <!-- <p class="colorWhite"><b>Date :</b>Date : {{ convertToLocalDate(element.sermonsDate) | date:'yyyy-MM-dd hh:mm a' }}</p>
                    <p class="colorWhite"><b>Language :</b> {{ element.category }}</p>
                    <p class="colorWhite"><b>Author :</b> {{ element.firstname }} {{ element.lastName }}</p> -->
        </div>
      </div>
      <div class="col-12 col-md-1 col-lg-1">
        <button
          (click)="handleSemonsClick(element.youtubeId)"
          type="button"
          class="playBtn"
        >
          <img src="./../../../assets/images/playBtn.png" class="img-fluid" />
        </button>
      </div>
    </div>
    <pagination-controls
      *ngIf="filtredSermonArray.length != 0"
      (pageChange)="paginate($event)"
      class="float-right"
    ></pagination-controls>
    <div *ngIf="filtredSermonArray.length == 0" class="text-center mt-5">
      No Sermons Found
    </div>
    <!-- <div class="text-center mt-5"><button type="button" class="btn btnPrimary">Load More</button></div> -->
  </div>
</div>
